exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-c5e8978c]{grid-area:UI;flex-direction:row;justify-content:space-between;padding:10px;background:var(--quaternary);box-shadow:0 1px 0 0 rgba(0,0,0,.2)}.container[data-v-c5e8978c],.profile[data-v-c5e8978c]{display:flex;align-items:center}.avatar[data-v-c5e8978c]{width:32px;height:32px;border-radius:50%;background:var(--grey)}.userdata[data-v-c5e8978c]{display:flex;flex-direction:column;margin-left:8px;font-size:13px}.userdata strong[data-v-c5e8978c]{display:block;color:var(--white)}.actions[data-v-c5e8978c],.userdata span[data-v-c5e8978c]{color:var(--grey)}.actions span[data-v-c5e8978c]{cursor:pointer;transition:.2s}.actions span[data-v-c5e8978c]:hover{color:var(--white)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c5e8978c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/User-Info/index.vue
// module id = 68
// module chunks = 0